module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"update_xendit":"Xendit","email":{"label":"Registered Xendit Email","placeholder":"Fill email registered in Xendit"},"account_list":{"label":"Account List","placeholder":"Write your secret key here"},"cancel":"Cancel","update":"Save","confirm":"Confirm"}}')
  delete Component.options._Ctor
}
